export default __webpack_public_path__ + "static/favicon-b06bb251949466e8c1628b3b6dcc1102.ico";